import apiClient from './apiClient';

export const taifunIntegrationApi = {
  get: async () => {
    const response = await apiClient.get('/taifun-integration');
    return response.data;
  },

  save: async (data) => {
    const response = await apiClient.post('/taifun-integration', data);
    return response.data;
  },

  delete: async () => {
    const response = await apiClient.delete('/taifun-integration');
    return response.data;
  },

  testConnection: async () => {
    const response = await apiClient.post('/taifun-integration/test');
    return response.data;
  },

  triggerSync: async () => {
    const response = await apiClient.post('/taifun-integration/sync');
    return response.data;
  },

  getStatus: async () => {
    const response = await apiClient.get('/taifun-integration/status');
    return response.data;
  },

  getLogs: async (params = {}) => {
    const response = await apiClient.get('/taifun-integration/logs', { params });
    return response.data;
  },
};
